/*
	Обновляем заголовок чата
*/
import { updateSessionTitle } from "../../../../../../../../../shared/api/sessions";

export const updateChatTitleService = async (
	session_id: string,
	user_id: string,
	title: string,
) => {
	const data = await updateSessionTitle({
		session_id,
		user_id,
		body: { title },
	});
	return data;
};
